export default __webpack_public_path__ + "static/media/home-seo-agency-bg-02.de621d8c.jpg";